import React from "react";
import { motion } from "framer-motion";

const ClientMarquee = () => {
  // Using high-end typography placeholders since actual logo images aren't present in assets yet.
  // These are designed to look like premium corporate wordmarks.
  const clients = [
    { name: "X-Core", style: "font-sans font-black tracking-[0.2em]" },
    { name: "Nate's Pharmacy", style: "font-serif font-bold italic tracking-wide" },
    { name: "Amarpatra Foods", style: "font-sans font-light tracking-[0.2em]" },
    { name: "Winelam Cosmetics", style: "font-mono font-bold tracking-tight" },
    { name: "AURA COSMETICS", style: "font-serif tracking-widest" },
    { name: "KanhaRas Foods", style: "font-sans font-extrabold tracking-[0em]" },
    { name: "VITALITY", style: "font-sans font-medium tracking-[0.3em]" },
    {
      name: "Sealinking International",
      style: "font-sans font-bold tracking-normal text-blue-900",
    },
  ];

  // We duplicate the array to create a seamless infinite loop
  const duplicatedClients = [...clients, ...clients, ...clients];

  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="py-12 bg-white border-b border-gray-100 overflow-hidden relative"
    >
      <div className="max-w-[1240px] mx-auto px-6 mb-10 text-center">
        <p className="text-sm font-bold text-gray-400 uppercase tracking-[0.2em]">
          Trusted by Top Brands Worldwide
        </p>
      </div>

      {/* Marquee Container */}
      <div className="relative flex overflow-hidden group max-w-[1440px] mx-auto">
        {/* Left Fade Gradient for seamless entry */}
        <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>

        {/* Right Fade Gradient for seamless exit */}
        <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

        {/* Scrolling Content - pauses on hover */}
        <div className="animate-marquee whitespace-nowrap flex items-center group-hover:[animation-play-state:paused]">
          {duplicatedClients.map((client, index) => (
            <div
              key={index}
              className="mx-6 md:mx-12 flex items-center justify-center opacity-40 hover:opacity-100 transition-opacity duration-300 cursor-pointer"
            >
              <span
                className={`text-2xl md:text-3xl text-gray-800 ${client.style}`}
              >
                {client.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style jsx="true">{`
        @keyframes marquee {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-33.3333%);
          }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
          /* Ensure width is wide enough to contain the triplicated content smoothly */
          width: fit-content;
        }
      `}</style>
    </motion.section>
  );
};

export default ClientMarquee;
